'use strict';

/**
 * Collection for the images in vreate process
 *
 * @category   Collection
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ImageModel = require('../models/image');

var ImagesCollection = Collection.extend({
    api: '/assets',
    model: ImageModel,

    initialize: function(options) {
        Collection.prototype.initialize.apply(this, arguments);

        this.on('change:main', function(changedModel, newValue) {
            if (newValue === true) {
                this.each(function(model, index) {
                    if (model.cid !== changedModel.cid) {
                        model.set('main', false);
                    }
                });
            }
        }.bind(this));

        // @todo deactivated because too confusing without animations
        // this.on('change:main', function(changedModel, newValue) {
        //     if (newValue === true) {
        //         var list  = [];
        //         var mainIndex = 0;
        //         this.each(function(model, index) {
        //             if (model.cid !== changedModel.cid) {
        //                 model.set('main', false);
        //             }  else {
        //                 mainIndex = index;
        //             }

        //             list.push(model);
        //         }.bind(this));

        //         if (mainIndex > 0) {
        //             var beforeMain = _.first(list, mainIndex);
        //             var mainUntilEnd = _.rest(list, mainIndex);

        //             // Reset collection
        //             this.reset(mainUntilEnd.concat(beforeMain));
        //         }
        //     }
        // }.bind(this));
    },

    getSortedImageIds: function() {
        var mainIndex;
        var imageIds = [];

        this.each(function(model, index) {
            if (model.get('main') === true) {
                mainIndex = index;
            }

            imageIds.push(model.get('id'));
        });

        if (mainIndex > 0) {
            var beforeMain = _.first(imageIds, mainIndex);
            var mainUntilEnd = _.rest(imageIds, mainIndex);

            // Reset collection
            imageIds = mainUntilEnd.concat(beforeMain);
        }

        return imageIds;
    },
});

module.exports = ImagesCollection;